import { BrowserRouter } from 'react-router-dom';
import { FronteggProvider } from '@frontegg/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import runtimeEnv from '~/shared/utils/runtimeEnv';
import Toaster from '~/shared/components/Toaster';
import { AuthContextProvider } from '~/shared/context/AuthContext';

import AppRoutes from './AppRoutes';

const contextOptions = {
  baseUrl: runtimeEnv.fronteggBaseUrl,
  clientId: runtimeEnv.fronteggClientId,
};

const authOptions = {
  keepSessionAlive: true,
};
const queryClient = new QueryClient();

function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <FronteggProvider
        contextOptions={contextOptions}
        hostedLoginBox={true}
        authOptions={authOptions}
      >
        <QueryClientProvider client={queryClient}>
          <AuthContextProvider>
            <AppRoutes />
          </AuthContextProvider>
        </QueryClientProvider>
      </FronteggProvider>
    </BrowserRouter>
  );
}

export default App;
